/*<![CDATA[*/
(function () {
    var scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
    if (window.ShopifyBuy) {
        if (window.ShopifyBuy.UI) {
            ShopifyBuyInit();
        } else {
            loadScript();
        }
    } else {
        loadScript();
    }
    function loadScript() {
        var script = document.createElement('script');
        script.async = true;
        script.src = scriptURL;
        (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
        script.onload = ShopifyBuyInit;
    }
    function ShopifyBuyInit() {
        var client = ShopifyBuy.buildClient({
            domain: 'hrm01.myshopify.com',
            storefrontAccessToken: '9e3cc5429b0e0ef07a7a046a296b950f',
        });
        ShopifyBuy.UI.onReady(client).then(function (ui) {
            ui.createComponent('product', {
                id: '8116076937395',
                node: document.getElementById('product-component-1733894546671'),
                moneyFormat: '%24%7B%7Bamount%7D%7D',
                options: {
                    "product": {
                        "styles": {
                            "product": {
                                "@media (min-width: 601px)": {
                                    "max-width": "calc(25% - 20px)",
                                    "margin-left": "20px",
                                    "margin-bottom": "50px"
                                }
                            },
                            "button": {
                                "font-family": "Jura, sans-serif",
                                "font-weight": "bold",
                                ":hover": {
                                    "background-color": "#4b5173"
                                },
                                "background-color": "#5b618f",
                                ":focus": {
                                    "background-color": "#4b5173"
                                },
                                "border-radius": "0px",
                                "padding-left": "20px",
                                "padding-right": "20px"
                            }
                        },
                        "contents": {
                            "img": false,
                            "title": false,
                            "price": false
                        },
                        "text": {
                            "button": "Add to cart"
                        },
                        "googleFonts": [
                            "Jura"
                        ]
                    },
                    "productSet": {
                        "styles": {
                            "products": {
                                "@media (min-width: 601px)": {
                                    "margin-left": "-20px"
                                }
                            }
                        }
                    },
                    "modalProduct": {
                        "contents": {
                            "img": false,
                            "imgWithCarousel": true,
                            "button": false,
                            "buttonWithQuantity": true
                        },
                        "styles": {
                            "product": {
                                "@media (min-width: 601px)": {
                                    "max-width": "100%",
                                    "margin-left": "0px",
                                    "margin-bottom": "0px"
                                }
                            },
                            "button": {
                                "font-family": "Jura, sans-serif",
                                "font-weight": "bold",
                                ":hover": {
                                    "background-color": "#525781"
                                },
                                "background-color": "#5b618f",
                                ":focus": {
                                    "background-color": "#525781"
                                },
                                "border-radius": "0px",
                                "padding-left": "20px",
                                "padding-right": "20px"
                            }
                        },
                        "googleFonts": [
                            "Jura"
                        ],
                        "text": {
                            "button": "Add to cart"
                        }
                    },
                    "option": {},
                    "cart": {
                        "styles": {
                            "button": {
                                "font-family": "Jura, sans-serif",
                                "font-weight": "bold",
                                ":hover": {
                                    "background-color": "#525781"
                                },
                                "background-color": "#5b618f",
                                ":focus": {
                                    "background-color": "#525781"
                                },
                                "border-radius": "0px"
                            }
                        },
                        "text": {
                            "total": "Subtotal",
                            "button": "Checkout"
                        },
                        "googleFonts": [
                            "Jura"
                        ]
                    },
                    "toggle": {
                        "styles": {
                            "toggle": {
                                "font-family": "Jura, sans-serif",
                                "font-weight": "bold",
                                "background-color": "#5b618f",
                                ":hover": {
                                    "background-color": "#525781"
                                },
                                ":focus": {
                                    "background-color": "#525781"
                                }
                            }
                        },
                        "googleFonts": [
                            "Jura"
                        ]
                    }
                },
            });
        });
    }
})();
/*]]>*/
